var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ts-x-black",class:_vm.classes,style:(_vm.styleObj),on:{"click":(e) => _vm.handleClick(e),"mouseover":function($event){_vm.state.hover = true},"mouseleave":function($event){_vm.state.hover = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }